<template>
    <div class="vm-block-discount">
        <h2 class="fsl16">{{$t('c.BlockDiscount.text1')}}</h2>
        <div class="content mt16">
            <p class="fs12">{{$t('c.BlockDiscount.text2')}}</p>
            <p class="fs12 black-5 mt8">{{$t('c.BlockDiscount.text3')}}<br>
                {{$t('c.BlockDiscount.text4')}}<br>
                {{$t('c.BlockDiscount.text5')}}</p>
        </div>
        <div class="discount-tab-box mt24">
            <div class="discount-tab-item" :class="{on: discount_option == 0}" @click="tab(0)">
                <radio-icon class="mr16" :class="{on: discount_option == 0}"></radio-icon>
                <div>
                    <div class="black-8 fwb">{{$t('c.BlockDiscount.text6')}}</div>
                    <!--<div class="fs12 black-5 mt8">粉丝按照赞助方案原价支付</div>-->
                </div>
            </div>
            <div class="discount-tab-item" :class="{on: discount_option == 1}" @click="tab(1)">
                <radio-icon class="mr16" :class="{on: discount_option == 1}"></radio-icon>
                <div>
                    <div class="black-8 fwb">{{$t('c.BlockDiscount.text7')}}</div>
                    <div class="fs12 black-5 mt8">{{$t('c.BlockDiscount.text8')}}<br>
                        {{$t('c.BlockDiscount.text9')}}<br>
                        {{$t('c.BlockDiscount.text10')}}<br>
                        {{$t('c.BlockDiscount.text11')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import { POST_CREATOR_DISCOUNT_OPTION } from '@/api/config'
    export default {
        name: 'block-discount',
        data(){
            return {
            }
        },
        computed:{
            ...mapState('app',[
                'session_user',
                'browser_size'
            ]),
            is_creator(){
                if(this.session_user && this.session_user.creator && this.session_user.creator.status){
                    return true
                }
                return false
            },
            tit(){
                if(!this.is_creator){
                    return '成为创作者'
                }
                return '设置'
            },
            discount_option(){
                if(this.session_user && this.session_user.creator){
                    return this.session_user.creator.discount_option
                }
                return 0
            }
        },
        async mounted(){

        },
        methods:{
            async tab(discount_option){
                if(discount_option == this.discount_option){
                    return false
                }
                if(this.$http.is_run(POST_CREATOR_DISCOUNT_OPTION)){
                    return false
                }
                let data = await this.$http.$axios(POST_CREATOR_DISCOUNT_OPTION, {status: discount_option})
                if(data.ec != 200){
                    this.$notify({
                        title: data.em,
                        group: 'error',
                    })
                    return false;
                }
                this.$notify({
                    title: data.em,
                    group: 'success',
                })
                this.session_user.creator.discount_option = discount_option
                if(discount_option == 1){
                    this.open_tip()
                }
            },
            open_tip(){
                // this.$modal.show(() => import('@/components/ModalDiscountTip'), {
                // },{
                //     pivotY: this.browser_size == 'small' ? 0.5 : 0.2,
                //     classes:'v--modal-select-month v--modal',
                //     height:this.browser_size == 'small' ? '100%' : 'auto',
                //     width: this.browser_size == 'small' ? '100%' : 360,
                //     adaptive: this.browser_size == 'small' ? true : false,
                // })
            }
        }
    };
</script>

<style lang="stylus" scoped>
.vm-block-discount{
    .discount-tab-box{
        display flex
    }
    .discount-tab-item{
        border-radius px2rem(4)
        border 1px solid $grey
        padding px2rem(16)
        box-sizing border-box
        background $white
        flex 1
        display flex
        align-items baseline
        cursor pointer
        &:hover{
            //box-shadow $layer-shadow
        }
        .radio{
            border-radius 1000px
            border 2px solid $black-3
            display flex
            align-items center
            justify-content center
            padding px2rem(4)
            &:after{
                content ''
                display block
                border-radius 1000px
                background transparent
                height px2rem(8)
                width px2rem(8)
            }
        }
        &:first-child{
            margin-right px2rem(24)
        }
        &.on{
            border-color $purple
            box-shadow $layer-shadow
            .radio{
                border-color $purple
                &:after{
                    background $purple
                }
            }
        }
    }
    @media (max-width: $width-mobile) {
        .discount-tab-box{
            flex-direction column
        }
        .discount-tab-item {
            &:first-child {
                margin-right px2rem(0)
            }
            &:last-child {
                margin-top px2rem(16)
            }
        }
    }
}
</style>
